export const graphqlUnifiedProductQuery = `
query ProductDetail($productUri: String!) {
  product(by: { uri: $productUri }) {
    attributes {
      customAttributes {
        key
        value {
          ... on StringValue {
            value
          }
          ... on NumberValue {
            numValue: value
          }
          ... on BooleanValue {
            boolValue: value
          }
          ... on ArrayValue {
            values
          }
        }
        attributeType
      }
      highlyRated
      starBrand
    }
  }
}
`;
